var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":"rgba(255, 255, 255, 0)","elevation":"0"}},[_c('v-card-text',{staticClass:"text-center py-0 my-0"},[_c('h1',{staticClass:"font-weight-black hidden-xs-only display-3",class:{
        'text-h3': _vm.$vuetify.breakpoint.smAndDown,
        'text-h1': _vm.$vuetify.breakpoint.h1,
      },staticStyle:{"color":"white","font-size":"5rem"}},[_vm._v(" "+_vm._s(_vm.title.toUpperCase())+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }